export default __webpack_public_path__ + "img/search_dark_gray.86713145.svg";